/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Diagram_Try_AgainInputs */



/**
* | output |
* | --- |
* | "Try Again" |
*
* @param {Diagram_Try_AgainInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const diagram_try_again = /** @type {((inputs?: Diagram_Try_AgainInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Diagram_Try_AgainInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Erneut versuchen")
	return /** @type {LocalizedString} */ ("Try Again")
});